module.exports = {"endpoint":"https://api.hkep.com/lrs/data/xAPI/","username":"171d60d7f2ae9b0725872677b78278464dc562a5","password":"f8e58db04f6f74cd1ecf990750775c6d1063f6ee","allowFail":false}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/json/xapi_config.json
// module id = lVGq
// module chunks = 2 3 4 5 6